import { browserHistory } from 'react-router';
import { call, select, takeEvery, delay } from 'redux-saga/effects';

import * as api from '../../services/contact/api_contact';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import { ENTITY, ENTITY_TYPE } from '../../constants/constant_doc_types';
import { CONTACT } from '../../constants/constant_entity_types';
import { attachStandardFieldValuesToCustomForm } from '../../services/apiUtils';
import { precheckEntity } from '../sagasCommonEntity';

export function* fetchListContactSaga(feathersApp) {
  yield takeEvery('FETCH_LIST_CONTACT', callListContact, feathersApp);
}

function* callListContact(feathersApp, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      doc_type: 'entity/contact',
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    console.log('tableData', tableData.total);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* deleteContactFromListSaga(feathersApp) {
  yield takeEvery('DELETE_CONTACT_FROM_LIST', callDeleteContactFromList, feathersApp);
}

function* callDeleteContactFromList(feathersApp, action) {
  yield deleteContact(feathersApp, action);
  yield delay(2000);
  yield callListContact(feathersApp, { silent: true });
}

function* deleteContact(feathersApp, action) {
  yield common.showProgressDeleteRecord();
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteContact, feathersApp, params);
    }
    yield common.doneDeleteRecord(id, ENTITY);
    return result;
  } catch (error) {
    yield common.showErrorDeleteRecord(error);
  }
}


export function* deleteContactSaga(feathersApp) {
  yield takeEvery('DELETE_CONTACT', callDeleteContact, feathersApp);
}

function* callDeleteContact(feathersApp, action) {
  const result = yield deleteContact(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/contact');
  }
}

export function* fetchContactForEditSaga(feathersApp) {
  yield takeEvery('FETCH_CONTACT_FOR_EDIT', callFetchContactForEdit, feathersApp);
}

function* callFetchContactForEdit(feathersApp, action) {
  const { tenant, user, subsidiary, path } = yield select();
  const { id, silent } = action;
  yield common.showProgressDataById(silent);
  try {
    let data;

    if (id) {
      const fetchParams = { tenant, user, id, path };
      const doc = yield call(api.fetchContactForEdit, feathersApp, fetchParams);

      (doc.contact_numbers || []).reverse();
      (doc.address_details || []).reverse();

      doc.custom_fields = yield call(
        attachStandardFieldValuesToCustomForm,
        doc,
        ENTITY,
      );

      data = doc;
    } else {
      const entityTypesParams = { cid: [CONTACT] };
      const defaultCurrency = subsidiary.primary_subsidiary.currency || {};
      const entityTypes = yield call(apiCommon.queryDocs, feathersApp, ENTITY_TYPE, entityTypesParams);

      data = {
        entity_type_ids: entityTypes.data.length ? [entityTypes.data[0].id]: [],
        active: true,
        contact_numbers: [{ primary: true, type: 'home' }],
        is_company: false,
        preferred_currency_id: defaultCurrency.id,
        preferred_currency: defaultCurrency,
      };
    }

    yield common.doneDataById(data);
  } catch (error) {
    yield common.showErrorDataById(error);
  }
}



export function* saveContactSaga(feathersApp) {
  yield takeEvery("SAVE_CONTACT", callSaveContact, feathersApp);
}
function* callSaveContact(feathersApp, action) {
  yield common.showProgressSaveRecord();
  const { tenant, user } = yield select();
  try {
    const ok = yield precheckEntity(feathersApp, action);
    if (!ok) {
      yield common.doneSaveRecord();
      return;
    }

    const result = yield call(api.saveContact, feathersApp, {
      tenant,
      user,
      data: action.data,
    });

    const id = result && result.id;

    if (id) {
      yield callFetchContactForEdit(feathersApp, { id, silent: true });
      browserHistory.push(`/admin/contact/edit/${id}`);
      yield common.doneSaveRecord(result, 'Contact was saved');
    } else {
      yield common.showErrorSaveRecord(new Error('Error in saving: Contact'));
    }
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
